export default __webpack_public_path__ + "static/media/edge-tooth.95c235df.PNG";